import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { DataStore } from './data-store';

/**
 * Defines a base class extended from DataStore but with additional caching cabailities
 */
export abstract class CachedDataStore<TData, TStoredData> extends DataStore<TData, TStoredData> {

    /**
     * Backing subject for dataCleared property
     */
    public get cachedValue(): TData {
        return this.internalCachedValue;
    }
    private internalCachedValue: TData;
    private cached = false;

    /**
     * Initializes a new instance of CachedDataStore<TData, TStoredData>
     */
    constructor() {
        super();
        this.rxjsLifetime.addSubscriptions(
            this.dataChanged.subscribe(data => this.internalCachedValue = data),
            this.dataCleared.subscribe(() => this.clearCache())
        );
    }

    /**
     * Gets the data value from the data store
     */
    public get(): Observable<TData> {
        if (this.cached) {
            return of(this.cachedValue);
        }
        return super.get().pipe(tap(data => {
            this.internalCachedValue = data;
            this.cached = true;
        }));
    }

    /**
     * Clears the cache from this data store
     */
    public clearCache(): void {
        this.cached = false;
        this.internalCachedValue = null;
    }
}
